// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import DropzoneController from "./dropzone_controller"
application.register("dropzone", DropzoneController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import SidebarController from "./sidebar_controller"
application.register("sidebar", SidebarController)

import SortableTableController from "./sortable_table_controller"
application.register("sortable-table", SortableTableController)
